import React, { forwardRef } from 'react';
import { ButtonBase } from './ButtonBase.js';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/**
 *
 *
 * Button is a low-level primitive that provides WAI-ARIA accessibility semantics, dependable keyboard interactions, consistent focus behavior, and that normalizes touch, press, and click interactions across different devices and input modalities.
 *
 * Buttons consist of a clickable area usually containing a textual label or an icon that users can click to perform an action. In addition, keyboard users may activate buttons using the Space or Enter keys.
 *
 * It allows user interactions, accessibility, internationalization, and behavior to be reused, while allowing custom styling and rendering to live within the definitions created for each product ecosystem.
 *
 * Button handles mouse, keyboard, and touch interactions, focus behavior, and ARIA props for both native button elements and custom element types.
 *
 * Note: If a visual label is not provided (e.g. an icon only button), then an aria-label or aria-labelledby prop must be passed to identify the button to assistive technology.
 *
 */
const Button = /*#__PURE__*/forwardRef(({
  children,
  ...props
}, forwardedRef) => {
  return /*#__PURE__*/React.createElement(ButtonBase, _extends({
    ref: forwardedRef,
    as: `button`
  }, props), children);
});
Button.displayName = 'Button';
var Button$1 = Button;

export { Button$1 as default };
